import { render, staticRenderFns } from "./ButtonWithConfirmationModal.vue?vue&type=template&id=18a94c89&"
import script from "./ButtonWithConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./ButtonWithConfirmationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports